import { render, staticRenderFns } from "./ParlayPremium.vue?vue&type=template&id=89143216&scoped=true&"
import script from "./ParlayPremium.vue?vue&type=script&lang=js&"
export * from "./ParlayPremium.vue?vue&type=script&lang=js&"
import style0 from "./ParlayPremium.vue?vue&type=style&index=0&id=89143216&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89143216",
  null
  
)

export default component.exports